export default {
  methods: {
    copyLinkToClipboard (text) {
      const input = document.createElement('input')

      input.value = text

      document.body.appendChild(input)
      input.select()

      try {
        document.execCommand('copy')
        this.$noty.success(this.$tr('common.copy_link_success'));
      } catch (err) {
        console.log(err)
      }

      document.body.removeChild(input)
    }
  }
}
